<span class="match" [hidden]="!isPasswordMatch"> Passwords must match </span>
